module.exports = __webpack_public_path__ + "static/media/ss-static-angular-schedule.563622e3.png";